import React from "react";

type Supplier = {
  _id: string;
  name: string;
  contactPerson?: string;
  phone?: string;
  email?: string;
  address?: string;
};

type Props = {
  suppliers: Supplier[];
  onEdit?: (id: string) => void;
  loading?: boolean;
};

const SupplierTable: React.FC<Props> = ({ suppliers, onEdit, loading }) => (
  <div className="overflow-x-auto bg-white text-gray-800 shadow rounded">
    <table className="min-w-full text-sm">
      <thead>
        <tr className="bg-gray-100">
          <th className="px-3 py-2 text-left text-gray-600">Name</th>
          <th className="px-3 py-2 text-left text-gray-600">Contact</th>
          <th className="px-3 py-2 text-left text-gray-600">Email</th>
          <th className="px-3 py-2 text-left text-gray-600">Address</th>
          <th className="px-3 py-2 text-left text-gray-600"></th>
        </tr>
      </thead>
      <tbody>
        {suppliers.map(s => (
          <tr key={s._id} className="border-b border-gray-200">
            <td className="px-3 py-2 font-medium">{s.name}</td>
            <td className="px-3 py-2">
              {s.contactPerson || "-"}<br />
              {s.phone}
            </td>
            <td className="px-3 py-2">{s.email}</td>
            <td className="px-3 py-2">{s.address || "-"}</td>
            <td className="px-3 py-2">
              {onEdit && (
                <button
                  className="text-blue-700 underline"
                  onClick={() => onEdit(s._id)}
                >
                  Edit
                </button>
              )}
            </td>
          </tr>
        ))}
        {!suppliers.length && !loading && (
          <tr>
            <td colSpan={5} className="text-center text-gray-400 py-8">No suppliers</td>
          </tr>
        )}
      </tbody>
    </table>
    {loading && <div className="text-center py-6 text-blue-700">Loading...</div>}
  </div>
);

export default SupplierTable;
